(function ($) {
  /* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true */
  /* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
  /* global Drupal, window, navigator, jQuery, $, console, generic, site, TweenMax, TimelineMax, location, Spinner, page_data */

  'use strict';

  Drupal.behaviors.ModuleFacechart = {
    attach: function (context, settings) {
      /*
			* @function getInternetExplorerVersion
			* @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
			* @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
			* @returns {Number} -1 if not any IE version, any other number otherwise
			*/
      function getInternetExplorerVersion() {
        var rv = -1,
          ua,
          re,
          verStringArr;

        // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
        if (navigator.appName === 'Microsoft Internet Explorer') {
          ua = navigator.userAgent;
          re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
          if (re.exec(ua) !== null) {
            rv = parseFloat(RegExp.$1);
          }
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
          rv = 11;
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
          ua = navigator.userAgent;
          re = new RegExp('Edge\/([0-9]{1,}[\.0-9]{0,})');
          verStringArr = re.exec(ua);
          if (verStringArr.length !== 0) {
            rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
          }
        }

        return rv;
      }

      /**
			* @function external:"jQuery.fn".quickshop
			* @description Creates quickshop functionality for target element(s)
			* @param {Object} options - Options for quickshop function
			* @param {boolean} debug [options.debug=false] - Whether to display debug messages or not
			* @returns {jQuery} - Target elements this function was called on
			*/
      jQuery.fn.quickshop = function (options) {
        // Note: QUICKSHOP SWITCH
        // Quickshop doesn't work on dynamic.li, we put this in so we dont ever have to worry about commenting out this block again
        if (window.location.href.indexOf('dynamic.li') > -1) {
          return;
        }

        var $ = jQuery,
          $this = $(this),
          product_ids = [],
          defaults = {
            debug: false
          };

        options = $.extend(defaults, options);

        if ($this.length === 0) {
          return;
        }

        // Build list of product ids
        // NOTE: each quickshop <a> should have a data-productID="PROD###" where ### is the specific product ID
        // If not it will attempt to parse the product url ex url : /product/12883/6600/Product-Catalog/Makeup/Accessories/Brushes/Concealer-Brush
        $this.each(function () {
          var
            $this = $(this),
            product_id,
            splitPathName;

          if (typeof $this.data('product') !== 'undefined') {
            product_id = $this.data('product');
          } else {
            var pathname = this.pathname;

            if (pathname.charAt(0) !== '/') {
              pathname = '/' + pathname;
            }

            splitPathName = pathname.split('/');

            if (splitPathName.length >= 3) {
              product_id = 'PROD' + splitPathName[3];
            }
          }

          if (typeof product_id !== 'undefined' && /^(PROD\d+)$/.test(product_id)) {
            if (options.debug) {
              console.log('quickshop: Found product id for : ', $this, ' with ' + product_id);
            }

            if (product_ids.indexOf(product_id) === -1) {
              product_ids.push(product_id);
            }
          } else if (options.debug) {
            console.log('quickshop: Failed to find product id for : ', $this, ' with ID ' + product_id, /^(PROD\d+)$/.test(product_id));
          }
        });

        if (options.debug) {
          console.log('quickshop: Found products: ' + product_ids);
        }

        // Run the fetch for all required fields for quickshop
        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: [
            {
              products: product_ids,
              'sku_fields': [
                'HEX_VALUE_STRING',
                'INVENTORY_STATUS',
                'LARGE_IMAGE',
                'MEDIUM_IMAGE',
                'PRICE',
                'PRODUCT_ID',
                'PRODUCT_SIZE',
                'SHADENAME',
                'SKU_BASE_ID',
                'SKU_ID',
                'XL_IMAGE',
                'XL_SMOOSH',
                'formattedPrice'
              ],
              product_fields: [
                'ATTRIBUTE_DESC_1',
                'ATTRIBUTE_DESC_2',
                'ATTRIBUTE_LABEL_1',
                'ATTRIBUTE_LABEL_2',
                'PRODUCT_DETAILS_MOBILE',
                'DEFAULT_CAT_ID',
                'DISPLAY_STATUS',
                'FAMILY_CODE',
                'MPP_DESC_1',
                'MPP_DESC_2',
                'PRODUCT_ID',
                'PROD_RGN_NAME',
                'PROD_RGN_SUBHEADING',
                'RATING_IMAGE',
                'SHORT_DESC',
                'TOTAL_REVIEW_COUNT',
                'priceRange',
                'shaded',
                'sized',
                'skus',
                'url'
              ]
            }
          ],
          onSuccess: function (results) {
            var product_results;

            if (options.debug) {
              console.log('quickshop: Success: Checking results: ', results);
            }

            if (typeof results === 'undefined' || typeof results.getValue === 'undefined' || typeof results.getValue().products === 'undefined' || results.getValue().products.length === 0) {
              return;
            }

            product_results = results.getValue().products;

            if (options.debug) {
              console.log('quickshop: Success: ', product_results);
            }

            if (product_results.length === 0) {
              return;
            }

            // Match product ID with product data with same product ID and save as a data attribute
            $this.each(function () {
              var $this = $(this);
              var product = $this.data('product');
              var sku = $this.data('sku');
              var productResult;
              var p = 0;
              var s = 0;

              // Must have a filled product ID
              if (typeof product === 'undefined' || product.length === 0) {
                if (options.debug) {
                  console.log('quickshop: Failed to associate product ID: ' + product + ' data with: ', $this);
                }

                return;
              }

              for (p = 0; p < product_results.length; p++) {
                // Deep copy product data, as stuff might change
                productResult = $.extend(true, {}, product_results[p]);
                if (product === productResult.PRODUCT_ID) {
                  if (options.debug) {
                    console.log('quickshop: Successfully associated product ID: ' + product + ' data with: ', $this);
                  }

                  if (typeof sku !== 'undefined' && sku.length !== 0 && productResult.skus.length !== 0) {
                    if (options.debug) {
                      console.log('quickshop: SKU found: Modifying SKU array', productResult.skus);
                    }

                    // Swap sku to beginning of the array
                    for (s = 0; s < productResult.skus.length; s++) {
                      if (productResult.skus[s].SKU_ID === sku) {
                        if (options.debug) {
                          console.log('quickshop: SKU found for ' + sku + ' ' + s);
                        }
                        productResult.skus.unshift(productResult.skus.splice(s, 1)[0]);
                        break;
                      }
                    }
                  }

                  $this.data('product_data', productResult);

                  return;
                }
              }
            });

            // Event call to open quickshop
            $this.unbind('click').click(function (e) {
              var $this = $(this);

              if (options.debug) {
                console.log('quickshop: Attemping open ' + $this + ' with ' + $this.data('product') + ' with data ' + $this.data('product_id'));
              }

              // Do not do anything if there isn't any product_data associated with the quickshop
              if (typeof $this.data('product_data') === 'undefined') {
                return;
              }

              e.preventDefault();
              // Launch the quickshop						
              site.quickshop($this.data('product_data'));
            });
          },
          onFailure: function (error) {
            error = error.getError();
            var errorCode = error.code;
            var errorMessages = '\n';
            var e = 0;

            // Build messages					
            for (e = 0; e < error.data.messages.length; e++) {
              errorMessages += e + '): ' + error.data.messages[e].text + '\n';
            }

            if (options.debug) {
              console.log('quickshop: Error : With Error Code: ' + errorCode + ' and messages: ' + errorMessages);
            }
          }
        });

        return $this;
      };

      var $window = $(window);
      var $boutique = $('#facechart-container');
      var debug = false;
      var isMobile;
      var isDesktop;
      var isIpad;
      var ieVersion;
      var mobileSize = 767;

      {
        // Initial mobile checks (additional checks will be needed for 'desktop mobile' sizes)
        isMobile = typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        isDesktop = !isMobile;
        isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
        ieVersion = getInternetExplorerVersion();

        // set classes for desktop/mobile/ipad/ie
        if (isIpad) {
          $boutique.addClass('ipad');
        } else {
          $boutique.addClass(isMobile ? 'mobile' : 'desktop');
        }

        if (ieVersion !== -1) {
          $boutique.addClass('ie');
        }

        if (ieVersion === 9) {
          $boutique.addClass('ie-9');
        }

        if (isDesktop) {
          isMobile = $(window).width() <= mobileSize;
          if (isMobile) {
            $boutique.addClass('mobile');
          }
        }
      }

      // BEGIN: Global functionality
      (function () {
        var $videoPlayButtons = $boutique.find('.watch-video a');
        var $modalVideo = $boutique.find('#video_modal');
        var $videoHTML5 = $modalVideo.find('#video_player');
        var $closeButton = $modalVideo.find('.close_btn');
        var videoOptions = {
          'debug': false,
          'autoplay': true,
          'controls': 'controls'
        };
        // Resize handler that should trigger resize handling with a delay after a resize
        var resizeHandler = (function () {
          var resizeTimeout;

          return function () {
            // Do not allow resizeTimeout creation until timer run and resizeTimeout is undefined again
            if (typeof resizeTimeout !== 'undefined') {
              return;
            }

            resizeTimeout = window.setTimeout(function () {
              /*
								 Required for section load, unload, and update functions called by this function
								 There may be additional animations and functionality implemented in those functions that need to be called.
								 Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
							*/
              // Add mobile class if desktop class scales under mobile size
              if ($boutique.hasClass('desktop')) {
                if ($window.width() <= mobileSize && !$boutique.hasClass('mobile')) {
                  if (debug) {
                    console.log('resizeHandler: Desktop gained mobile');
                  }

                  $boutique.addClass('mobile');
                  isMobile = true;
                  $(window).trigger('desktopGainedMobile');
                } else if ($window.width() > mobileSize && $boutique.hasClass('mobile')) {
                  if (debug) {
                    console.log('resizeHandler: Desktop lost mobile');
                  }

                  $boutique.removeClass('mobile');
                  isMobile = false;
                  $(window).trigger('desktopLostMobile');
                }
              }

              // Clear timeout for re-creation
              resizeTimeout = undefined;
            }, 500);
          };
        })();

        // Initialize video player
        $videoHTML5.html5mediaplayer('init');

        // BEGIN: Events
        {
          $window.on('resize', resizeHandler).trigger('resize');

          $videoPlayButtons.on('click', function (e) {
            var $this = $(this);

            e.preventDefault();

            TweenMax.to($modalVideo, 1, {
              opacity: 1,
              display: 'table',
              onComplete: function () {
                $videoHTML5.html5mediaplayer('player', $this.attr('href'), videoOptions);
                $videoHTML5.find('video').attr('controls', 'controls');
                $videoHTML5.find('video').off('ended').on('ended', function () {
                  $closeButton.trigger('click');
                });
              }
            });
          });

          $modalVideo.on('click', function (e) {
            var $target = $(e.target);

            e.preventDefault();

            if ($target.is($modalVideo.find('.video_wrapper, video, #video_player'))) {
              return;
            }

            $closeButton.trigger('click');
          });

          $closeButton.on('click', function (e) {
            e.preventDefault();

            TweenMax.to($modalVideo, 1, {
              opacity: 0,
              display: 'none'
            });

            $videoHTML5.html5mediaplayer('destroy');
          });

          // Initial click event handling to prevent slides from progressing on link click
          $boutique.find('.mpp-add-all-to-bag-container').on('click', function (e) {
            e.preventDefault();
          });

          $boutique.find('.el_product .el-product_description .el-product_shop-now').on('click', function (e) {
            e.preventDefault();
          });

          $boutique.find('.el_product .quickshop-container.mobile .el-product_shop-now').on('click', function (e) {
            e.preventDefault();
          });

          // BEGIN: MPP Functionality
          $window.on('elProductReady', function () {
            var $products = $boutique.find('.mpp-grid .el-product');
            var customMPP;
            var productsData;

            // Desktop Quickshop Handling for MPPs generated
            // $boutique.find('.el-product_description .el-product_shop-now').quickshop({debug: false});

            // Make sure page_data is not undefined
            // Continue doing this for proceeding properties until products array is hit
            if (typeof page_data !== 'undefined') {
              customMPP = page_data['custom-mpp'];
              if (typeof customMPP !== 'undefined') {
                productsData = customMPP['products'];
              }
            }

            if (debug) {
              console.log('page_data', page_data, customMPP, productsData);
            }

            $products.each(function () {
              var $this = $(this);
              var productID = $this.data('product');
              var p = 0;
              var productData;
              var skus;
              var skuData;
              var skuAssigned = false;
              var s = 0;

              // Assign SKUs per product based on page_data values (if it exists)
              // ... And is an Array
              if (typeof productsData !== 'undefined' && productsData instanceof Array) {
                for (p = 0; p < productsData.length; p++) {
                  productData = productsData[p];
                  if (typeof productData.PRODUCT_ID !== 'undefined' && productData.PRODUCT_ID === productID) {
                    skus = productData.skus;
                    if (typeof skus !== 'undefined' && skus instanceof Array) {
                      // Use first sku data
                      skuData = skus[0];

                      // Otherwise search for sku data based on SKU id.
                      if (typeof $this.data('sku') !== 'undefined' && $this.data('sku').length !== 0) {
                        for (s = 0; s < skus.length; s++) {
                          skuData = skus[s];

                          if (skuData.SKU_ID === $this.data('sku')) {
                            break;
                          }
                        }
                      }

                      if (typeof skuData.SKU_ID !== 'undefined') {
                        $this.attr('data-sku-base-id', skuData.SKU_ID);
                        skuAssigned = true;
                        break;
                      }
                    }
                  }
                }
              }

              if (skuAssigned) {
                if (debug) {
                  console.log('sku assigned for ' + productID);
                } else {
                  if (debug) {
                    console.log('sku not assigned for ' + productID);
                  }
                  if (typeof $this.data('sku-base-id') === 'undefined') {
                    $this.attr('data-sku-base-id', '');
                  } // Assign empty sku to avoid crashes
                }
              }
            });

            $boutique.find('.el-product_description .el-product_shop-now').on('click', function (e) {
              e.preventDefault();

              site.quickshop($(this).data('full_product_json'));
            });

            // Mobile add to bag
            $boutique.find('.el-product .quickshop-container.mobile .el-product_shop-now').off('click').on('click', function (e) {
              var $this = $(this);
              var productID;
              var sku;

              e.preventDefault();

              if (!isMobile) {
                return;
              }

              productID = $this.data('product');
              sku = $this.data('sku');
              sku = typeof sku === 'undefined' ? '' : sku.replace(/[A-z]+/, '');

              if (typeof productID === 'undefined') {
                return;
              }

              site.addToCart({
                skuData: {
                  SKU_BASE_ID: sku,
                  PARENT_CAT_ID: productID
                },
                quantity: 1,
                QTY: 1
              });
            });

            $(document).on('addToCart.success', function () {
              $window.trigger('addAllToBag.success');
            }).on('addToCart.failure', function () {
              $window.trigger('addAllToBag.failure');
            });

            // Add all to bag
            $boutique.find('.mpp-add-all-to-bag-container').off('click').on('click', function (e) {
              e.preventDefault();

              var $this = $(this);
              // Get products for MPP
              var $products = $this.closest('.facechart-products').find('.mpp-grid .el-product');
              var productData;
              var productsToLoad = [];

              if (debug) {
                console.log('add all to bag: started: adding ' + $products.length + ' products');
              }

              // iterate through found products, collect their prod ID and sku ID attributes.
              // use those attributes for addToCart call
              $products.each(function () {
                var $this = $(this);

                if (typeof $this.data('product') === 'undefined' || $this.data('product').trim().length === 0 || typeof $this.data('sku-base-id') === 'undefined' || $this.data('sku-base-id').length === 0) {
                  if (debug) {
                    console.log('add all to bag: invalid: skipping: ', $this.data('product'), $this.data('sku-base-id'));
                  }

                  return;
                } else if (debug) {
                  console.log('add all to bag: valid: ', $this.data('product'), $this.data('sku-base-id'));
                }

                productsToLoad.push({
                  productID: $this.data('product'),
                  skuID: $this.data('sku-base-id').replace(/[A-z]+/, '') // On Mobile Estee, SKUs only take numbers only; i.e., 9515, not SKU9515
                });
              });
              // Start loading products
              productData = productsToLoad.pop();
              site.addToCart({
                skuData: {
                  SKU_BASE_ID: productData.skuID,
                  PARENT_CAT_ID: productData.productID
                },
                quantity: 1,
                QTY: 1
              });

              // Add next products to bag on either success or failure							
              $(window).off('addAllToBag.success addAllToBag.failure').on('addAllToBag.success addAllToBag.failure', function () {
                productData = productsToLoad.pop();

                if (typeof productData !== 'undefined') {
                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: productData.skuID,
                      PARENT_CAT_ID: productData.productID
                    },
                    quantity: 1,
                    QTY: 1
                  });
                }

                // No more products to add, clean up until next time
                if (typeof productData === 'undefined' || productData.length === 0) {
                  $(document).off('addAllToBag.success addAllToBag.failure');
                }
              });
            });
          });
          // END: MPP Functionality
        }
        // END: Events
      })();
      // END: Global functionality

      // BEGIN: Carousel functionality
      (function () {
        var $self = $boutique.find('.facechart-carousel');
        var $carousels = $self.find('.carousel_container');
        var $facechartIntroCarousel = $carousels.filter('.facechart-intro-container');
        var $facechartStepsCarousel = $carousels.filter('.facechart-steps-container');
        var $slides = $carousels.children();
        var $prev = $self.find('.prev');
        var $next = $self.find('.next');
        var dir = true; // Global direction flag to modify animation
        var currentTransitionTimeline;

        // BEGIN: Init
        {
          $carousels.el_carousel({
            debug: debug,
            increment: '100%',
            offset: '0%',
            useGSAP: true,
            duration: 1,
            callbackAnimation: jQuery.elCarouselgetStandardAnimationCallbacks().animateSlidesBasic,
            callbackAnimationOptions: {
              useClones: false
            }
          });

          $facechartIntroCarousel.children().first().addClass('first');
          $facechartStepsCarousel.children().first().addClass('first');

          // Trim trailing commas
          /*
					$boutique.find('.facechart-products').find('.el-product_id-list').each(function(){
						var $this = $(this);
						var content = $this.html();
				
						$this.html(content.substring(0, content.length-1));
					});
					*/

          // Run EL Product plugin
          $boutique.find('.facechart-products.natural-nude, .facechart-products.city-smart, .facechart-products.after-party, .facechart-products.red-haute').elproduct({
            'target': '.el-product',
            'template': '.hidden-products-markup-to-clone .el-product',
            'products': '.el-product_id-list',
            'onSuccess': function () {
              $window.trigger('elProductReady');
            },
            // 'products' : '.hidden_product_list',
            'debug': false
          });
        }
        // END: Init

        // BEGIN: Events
        {
          // Prev button progression
          $prev.on('click', function (e) {
            e.preventDefault();

            dir = false;

            $carousels.carouselPrev();
          });

          // Next button progression
          $next.on('click', function (e) {
            e.preventDefault();

            dir = true;

            $carousels.carouselNext();
          });

          // Key press progress
          $window.on('keydown', function (e) {
            var key = e.which;

            switch (key) {
              // Left arrow key
              case 37:
                $prev.trigger('click');
                break;

                // Right arrow Key
              case 39:
                $next.trigger('click');
                break;
            }
          });

          // Swipe controls for carousel progression
          $carousels.swipe({
            swipeLeft: function () {
              $next.trigger('click');
            },
            swipeRight: function () {
              $prev.trigger('click');
            },
            preventDefaultEvents: false,
            excludedElements: 'button, input, select, textarea, .noSwipe',
            threshold: 100
          });

          // Dot nav handling
          $boutique.find('.facechart-carousel_dots li').on('click', function (e) {
            var $this = $(this);
            var index = $this.index();
            var prevIndex = $boutique.find('.facechart-carousel_dots li.active').index();

            e.preventDefault();

            if (index === prevIndex) {
              return;
            }

            if (index > prevIndex) {
              dir = true;
            } else {
              dir = false;
            }

            $this.addClass('active').siblings().removeClass('active');

            $carousels.carouselTo(index);
          }).first().addClass('active');

          // Animation for when a slide has become active
          $facechartStepsCarousel.children().on('slideWillGainActive', function () {
            var $this = $(this);
            var $face = $this.find('.face');
            var $background = $face.find('.background');
            var $text = $this.find('.facechart_carousel-text');
            var $mpp = $this.find('.mpp-carousel');

            TweenMax.killTweensOf([$background, $text, $mpp]);

            currentTransitionTimeline = new TimelineMax({
              paused: true,
              delay: 0.5,
              onComplete: function () {
                currentTransitionTimeline = undefined;
              }
            });

            if (dir) {
              if (isMobile) {
                currentTransitionTimeline
                  .fromTo($background, 0.4, {
                    autoAlpha: 0,
                    x: '200%'
                  }, {
                    autoAlpha: 1,
                    x: '0%',
                    force3D: true
                  })
                  .fromTo($text, 1, { autoAlpha: 0 }, { autoAlpha: 1 }, '0.4')
                  .fromTo($mpp, 0.4, { autoAlpha: 0 }, { autoAlpha: 1 }, '0');
              } else {
                currentTransitionTimeline
                  .fromTo($background, 0.4, {
                    autoAlpha: 0,
                    x: '100%'
                  }, {
                    autoAlpha: 1,
                    x: '0%',
                    force3D: true
                  })
                  .fromTo($text, 1, { autoAlpha: 0 }, { autoAlpha: 1 }, '0.4')
                  .fromTo($mpp, 0.4, { autoAlpha: 0 }, { autoAlpha: 1 }, '0');
              }
            } else {
              if (isMobile) {
                currentTransitionTimeline
                  .fromTo($background, 0.4, {
                    autoAlpha: 0,
                    x: '-200%'
                  }, {
                    autoAlpha: 1,
                    x: '-1%',
                    force3D: true
                  })
                  .fromTo($text, 1, { autoAlpha: 0 }, { autoAlpha: 1 }, '0.4')
                  .fromTo($mpp, 0.4, { autoAlpha: 0 }, { autoAlpha: 1 }, '0');
              } else {
                currentTransitionTimeline
                  .fromTo($background, 0.4, {
                    autoAlpha: 0,
                    x: '-100%'
                  }, {
                    autoAlpha: 1,
                    x: '0%',
                    force3D: true
                  })
                  .fromTo($text, 1, { autoAlpha: 0 }, { autoAlpha: 1 }, '0.4')
                  .fromTo($mpp, 0.4, { autoAlpha: 0 }, { autoAlpha: 1 }, '0');
              }
            }

            currentTransitionTimeline.play();
          }).filter('.active').trigger('slideWillGainActive');

          /*
						Clicking on the product name now triggers quickshop
					*/
          $('.el-product .el-product_name').on('click', function (e) {
            var $this = $(this);
            var $parent = $this.closest('.el-product');
            var $quickshop = $parent.find('.el-product_shop-now.desktop');

            console.log($this, $parent, $quickshop);

            e.preventDefault();

            $quickshop.trigger('click');
          });

          $facechartStepsCarousel.on('carousel_updated', function () {
            var $this = $(this);
            var $activeChild = $this.children('.active');
            var index = $activeChild.index();

            $boutique.find('.facechart-carousel_dots li').eq(index).addClass('active').siblings().removeClass('active');
          }).first().trigger('carousel_updated'); // Ensure that the animation for the first slide is 'complete'

          /*
					$facechartStepsCarousel.children().find('video').on('error', function() {
						var $this = $(this);
						var $nextSource = ($this.find('source').not('.failed').first().addClass('failed').next('source'));
					
						console.log('error hit, switching sources');
					
						$this.attr('src', $nextSource.attr('src'));
						this.play();
					});
					*/

          $facechartStepsCarousel.children().on('slideHasGainedActive', function () {
            var $this = $(this);
            var $video = $this.find('video');

            // Play slide video on desktop only
            if (!isMobile) {
              if ($video.length !== 0) {
                // console.log('playing: ' + $video.find('source').attr('src'))					
                // $video[0].currentTime = 0;
                $video[0].play();
              }
            }
          });

          // Stop video when slide has lost active on desktop
          $slides.on('slideWillLoseActive', function () {
            var $this = $(this);
            var $video = $this.find('video');

            // Pause all videos in slide
            $video.each(function () {
              // console.log('paused: ' + $video.find('source').attr('src') + ' ' + this.paused)					
              if (!this.paused) {
                this.pause();
              }
            });
          });

          $window
            .on('desktopGainedMobile', function () {
              var $videos = $facechartStepsCarousel.find('video');

              // Pause all videos in slide
              $videos.each(function () {
                if (!this.paused) {
                  this.pause();
                }
              });
            })
            .on('desktopLostMobile', function () {
              var $activeSlide = $facechartStepsCarousel.children('.active');
              var $video = $activeSlide.find('video');

              if ($video.length !== 0) {
                $video[0].play();
              }
            });

          $facechartStepsCarousel.find('.play-button').on('click', function (e) {
            var $parent = $(this).closest('.face');
            var $video = $parent.find('video');

            e.preventDefault();

            $video[0].play();
          });

          // BEGIN: Mobile Steps
          (function () {
            {
              // Ensures animation values from event below are blown away when switching to mobile
              $window.on('desktopLostMobile', function () {
                $facechartStepsCarousel.find('.steps li').css({
                  height: '',
                  opacity: '',
                  display: ''
                });
              });

              // Handles mobile steps open and close
              $facechartStepsCarousel.find('.steps li').on('click', function (e) {
                var $this = $(this);
                var $stepsContent = $this.find('.steps-content');
                var $indicator = $this.find('.toggle-button');
                var $open = $indicator.find('.open');
                var $closed = $indicator.find('.closed');
                var timeline = new TimelineMax({ paused: true });

                if (!isMobile) {
                  return;
                }

                TweenMax.killTweensOf($stepsContent);

                if ($this.hasClass('open')) {
                  timeline
                    .to($stepsContent, 1, {
                      height: '0',
                      opacity: 0,
                      display: 'none',
                      clearProps: 'all'
                    })
                    .to($open, 1, { opacity: 0 }, '0')
                    .to($closed, 1, { opacity: 1 }, '0');

                  timeline.eventCallback('onComplete', function () {
                    $this.removeClass('open');
                  });
                  timeline.play();
                } else {
                  e.preventDefault();
                  $this.addClass('open');

                  $stepsContent.css({ height: 'auto' });

                  timeline
                    .to($stepsContent, 1, {
                      opacity: 1,
                      display: 'block'
                    })
                    .from($stepsContent, 1, {
                      height: 0,
                      immediateRender: false
                    }, '0')
                    .to($open, 1, { opacity: 1 }, '0')
                    .to($closed, 1, { opacity: 0 }, '0');

                  timeline.eventCallback('onComplete', function () {
                    $this.addClass('open');
                  });

                  timeline.play();
                }
              });
            }
          })();
          // END: Mobile Step
        }
        // END: Events

        // BEGIN: Facechart Intro
        (function () {
          var $facechartIntros = $carousels.find('.facechart-intro-image');

          // Facechart Intro Image Rollover Handling
          $facechartIntros
            .on('mouseenter', function () {
              var $this = $(this);
              var $on = $this.find('.on');
              var $indicator = $this.find('.rollover-zoom');
              var $indicatorPlus = $indicator.find('.plus');
              var $indicatorMinus = $indicator.find('.minus');
              var timeline = new TimelineMax({
                paused: true
              });

              if (isMobile) {
                return;
              }

              TweenMax.killTweensOf([$this, $on, $indicator.find('img')]);
              $this.addClass('open');

              timeline
                .to($indicatorPlus, 0.2, { opacity: 0 })
                .to($indicatorMinus, 0.2, { opacity: 1 }, '0')
                .to($on, 0.2, {
                  display: 'block',
                  opacity: 1
                }, '0');

              timeline.play();
            })
            .on('mouseleave', function () {
              var $this = $(this);
              var $on = $this.find('.on');
              var $indicator = $this.find('.rollover-zoom');
              var $indicatorPlus = $indicator.find('.plus');
              var $indicatorMinus = $indicator.find('.minus');
              var timeline = new TimelineMax({
                paused: true
              });

              if (isMobile) {
                return;
              }

              TweenMax.killTweensOf([$this, $on, $indicator.find('img')]);
              $this.removeClass('open');

              timeline
                .to($indicatorPlus, 0.2, { opacity: 1 })
                .to($indicatorMinus, 0.2, { opacity: 0 }, '0')
                .to($on, 0.2, {
                  display: 'none',
                  opacity: 0
                }, '0');

              timeline.play();
            })
            .on('click', function (e) {
              var $this = $(this);
              var $on = $this.find('.on');
              var $indicator = $this.find('.rollover-zoom');
              var $indicatorPlus = $indicator.find('.plus');
              var $indicatorMinus = $indicator.find('.minus');
              var timeline = new TimelineMax({ paused: true });

              e.preventDefault();

              TweenMax.killTweensOf([$this, $on, $indicator.find('img')]);

              if ($this.hasClass('open')) {
                timeline
                  .to($indicatorPlus, 0.2, { opacity: 1 }, '0')
                  .to($indicatorMinus, 0.2, { opacity: 0 }, '0')
                  .to($on, 0.2, {
                    display: 'none',
                    opacity: 0
                  }, '0');

                $this.removeClass('open');
              } else {
                timeline
                  .to($indicatorPlus, 0.2, { opacity: 0 }, '0')
                  .to($indicatorMinus, 0.2, { opacity: 1 }, '0')
                  .to($on, 0.2, {
                    display: 'block',
                    opacity: 1
                  }, '0');

                $this.addClass('open');
              }

              timeline.play();
            });

          // Opens quickshop menu under each item in the MPP
          $facechartStepsCarousel.find('.quickshop_btn').on('click', function (e) {
            var $parent = $(this).closest('.el-product');

            e.preventDefault();

            if (!isMobile) {
              return;
            }

            $parent.toggleClass('open').siblings().removeClass('open');
          });

          // Close all quickshop menus under each items in the mpp.
          $window.on('desktopLostMobile', function () {
            $facechartStepsCarousel.find('.quickshop_btn').removeClass('open');
          });
        })();
        // END: Facechart Intro
      })();
      // END: Carousel Functionality
      // });

      // BEGIN: Deeplink handling
      (function () {
        var enableDeeplink = false;
        var $carousels = $boutique.find('.carousel_container');
        var $facechartIntroCarousel = $carousels.filter('.facechart-intro-container');
        var $facechartStepsCarousel = $carousels.filter('.facechart-steps-container');
        var $sectionProducts = $carousels.find('.facechart-products').first();
        var sections = [$facechartIntroCarousel, $facechartStepsCarousel.find('.slide_wrapper').first(), $sectionProducts];

        // Set deeplink on current scroll
        $window.on('scroll', function () {
          var scrollTop = $window.scrollTop();
          // Assumes all sections don't deviate in height
          var i = 0;

          if (!enableDeeplink) {
            return;
          }

          // Current deeplink is based on scroll position past section's offset top
          (function () {
            var $section;
            var currentIndex = 0;

            for (i = 0; i < sections.length; i++) {
              $section = sections[i];

              if (scrollTop >= $section.offset().top) {
                currentIndex = i;
              }
            }

            location.replace('#/' + currentIndex);
          })();
        });

        // Go to deeplink
        $window.on('deeplink', function () {
          var rawHash = location.hash.split('/');
          var targetIndex = 0;
          var targetScroll;

          if (rawHash.length < 2) {
            return;
          }

          enableDeeplink = false;

          targetIndex = parseInt(rawHash[rawHash.length - 1]);
          targetScroll = targetIndex !== 0 ? sections[targetIndex].offset().top : 0;

          TweenMax.to($window, 1, {
            scrollTo: {
              y: targetScroll,
              onAutoKill: function () {
                enableDeeplink = true;
              }
            },
            onComplete: function () {
              enableDeeplink = true;
            }
          });
        });
      })();
      // END: Deeplink handling

      // BEGIN: Preloader
      (function () {
        var $loader = $boutique.find('#loader'),
          spinnerOptions = {
            lines: 17, // The number of lines to draw
            length: 0, // The length of each line
            width: 5, // The line thickness
            radius: 26, // The radius of the inner circle
            scale: 1, // Scales overall size of the spinner
            corners: 1, // Corner roundness (0..1)
            color: '#000', // #rgb or #rrggbb or array of colors
            opacity: 0.5, // Opacity of the lines
            rotate: 0, // The rotation offset
            direction: 1, // 1: clockwise, -1: counterclockwise
            speed: 1, // Rounds per second
            trail: 30, // Afterglow percentage
            zIndex: 2e9, // The z-index (defaults to 2000000000)
            className: 'spinner', // The CSS class to assign to the spinner
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            shadow: false, // Whether to render a shadow
            hwaccel: true, // Whether to use hardware acceleration
            position: 'absolute' // Element positioning
          },
          spinner = new Spinner(spinnerOptions).spin($loader[0]);

        $boutique.find('img').FreeLoader({
          callback: function () {
            TweenMax.to($loader, 1, {
              opacity: 0,
              display: 'none',
              onComplete: function () {
                spinner.stop();
                $(window).trigger('postLoad');
                $(window).trigger('deeplink');
              }
            });
          }
        });
      })();
      // END: Preloader
    }
  };
})(jQuery);
